import { supabase } from '../lib/supabase';

// Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(toCamelCase);

  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    acc[camelKey] = typeof obj[key] === 'object' ? toCamelCase(obj[key]) : obj[key];
    return acc;
  }, {});
};

// Convert camelCase to snake_case
const toSnakeCase = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(toSnakeCase);

  return Object.keys(obj).reduce((acc, key) => {
    const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
    acc[snakeKey] = typeof obj[key] === 'object' ? toSnakeCase(obj[key]) : obj[key];
    return acc;
  }, {});
};

export const companyService = {
  async getAllCompanies() {
    try {
      const { data, error } = await supabase
        .from('companies')
        .select('id, company_name, logo_url')
        .order('company_name', { ascending: true });

      if (error) throw error;
      return (data || []).map(toCamelCase);
    } catch (error) {
      console.error('Error fetching companies:', error?.message);
      throw error;
    }
  },

  async createCompany(input) {
    try {
      const snakeData = toSnakeCase(input);

      // domain is NOT NULL UNIQUE in DB — generate one if not provided
      if (!snakeData.domain) {
        const slug = (input.companyName || '')
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
        snakeData.domain = `${slug}-${Date.now()}`;
      }
      const { data, error } = await supabase
        .from('companies')
        .insert(snakeData)
        .select('id, company_name')
        .single();

      if (error) {
        // Código 23505 = unique_violation en PostgreSQL
        if (error.code === '23505') {
          const dupError = new Error(error.message);
          dupError.code = 'DUPLICATE_NAME';
          throw dupError;
        }
        if (error.code === '42501') {
          const permError = new Error(error.message);
          permError.code = 'PERMISSION_DENIED';
          throw permError;
        }
        const unknownError = new Error(error.message);
        unknownError.code = 'UNKNOWN';
        throw unknownError;
      }

      return toCamelCase(data);
    } catch (error) {
      if (error.code === 'DUPLICATE_NAME' || error.code === 'PERMISSION_DENIED' || error.code === 'UNKNOWN') {
        throw error;
      }
      console.error('Error creating company:', error?.message);
      const unknownError = new Error(error.message);
      unknownError.code = 'UNKNOWN';
      throw unknownError;
    }
  }
};
